import { render, staticRenderFns } from "./GraphComponent.vue?vue&type=template&id=271f2474&"
import script from "./GraphComponent.vue?vue&type=script&lang=ts&"
export * from "./GraphComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports